import React from 'react';
import { PageTitle } from '../PageTitle';
import { Redirect } from 'react-router-dom';
import { UsersService, RolesService } from '../../services';
import i18next from 'i18next';

class UserView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      user: null,
      userId: props.match.params.userId,
      errorMessage: null,
      roleTypes: null
    };
  }

  componentDidMount() {
    UsersService.get(this.state.userId).then((response) => {
      this.setState({ user: response.user });
    }).catch((error) => {
      this.setState({ errorMessage: i18next.t('messages.could-not-load-user-view') });
      console.log(error);
    });
    RolesService.getAllRoleTypes().then((response) => {
      let roleTypes = response.roleTypes.filter(type => type.token != "responsibility_role")
      this.setState({ roleTypes: roleTypes });
    }).catch((error) => {
      this.setState({ errorMessage: i18next.t('messages.could-not-load-role-types') });
      console.error(error);
    });
  }

  render() {
    if (this.state.errorMessage) {
      return (
          <Redirect to={{
            pathname: '/admin/users',
            state: {
              errorMessage: this.state.errorMessage
            }
          }}/>
      );
    }

    if (this.state.user && this.state.roleTypes) {
      const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
      const searchTerms = this.props.location.state && this.props.location.state.searchTerms ? this.props.location.state.searchTerms : null;
      return (
          <UserDetail
            user={this.state.user}
            roleTypes ={this.state.roleTypes}
            backLinkSearch={backLinkSearch}
            searchTerms={searchTerms}
          />
      );
    } else {
      return (
          <div className="loader">{i18next.t('loading')}</div>
      );
    }
  }

}

class UserDetail extends React.Component {
  render() {
    return (
        <div>
          <div className="row">
            {
              this.props.user.managedExternally ?
              <PageTitle title={`${this.props.user.firstName} ${this.props.user.lastName}`}
                       backLinkWithParams= {{
                         link: {
                           pathname: "/admin/users",
                           search: this.props.backLinkSearch,
                           state: { searchTerms: this.props.searchTerms }
                         }
                       }} /> :
              <PageTitle title={`${this.props.user.firstName} ${this.props.user.lastName}`}
                       backLinkWithParams= {{
                         link: {
                           pathname: "/admin/users",
                           search: this.props.backLinkSearch,
                           state: { searchTerms: this.props.searchTerms }
                         }
                       }}
                       editLinkWithParams={{
                         link: {
                           pathname: `/admin/users/edit/${this.props.user.id}`,
                           uiroute: '/admin/users/edit/:userId',
                           state: {
                             backLinkSearch: this.props.backLinkSearch,
                             searchTerms: this.props.searchTerms
                           }
                         }
                       }} />                       
            }            
          </div>

          <div className="op-content-box">
            <div className="row">
              <div className="col-sm-4 col-md-3 form-group">
                <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-name">
                  <label>{i18next.t('table-headers.name')}</label><p>{this.props.user.firstName} {this.props.user.lastName}</p>
                </div>
              </div>
              <div className="col-sm-4 col-md-3 form-group">
                <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-name">
                  <label>{i18next.t('table-headers.username')}</label> <p>{this.props.user.username}</p>
                </div>
              </div>
              <div className="col-sm-4 col-md-3 form-group">
                <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-business-structure">
                  <label>{i18next.t('table-headers.enterprise')}</label> <p>{this.props.user.enterprise.name}</p>
                </div>
              </div>
              <div className="col-sm-4 col-md-3 form-group">
                <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-description">
                  <label>{i18next.t('pages.users.language')}</label> <p>{this.props.user.locale.description}</p>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 form-group">
                <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-roles">
                  <label>{i18next.t('form-labels.roles')}</label>
                  <div> 
                  {
                    this.props.user.roles == null || this.props.user.roles.length === 0 ?
                      (<em>{i18next.t('messages.user-no-role-assigned')}</em>)
                      :
                      this.props.roleTypes.map((element, index) =>
                        <div className="form-group col-sm-12 col-lg-6" key = {index}>
                            <label>{i18next.t(`role-types.${element.token}`)}</label>
                            {
                              this.props.user.roles.filter(role => role.roleType.token == element.token).map(role => <span className="role-list" key={role.id}>{role.name}</span>)
                            }
                          </div>
                      )
                  }
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 form-group card-data-cell-icon card-icon-name">
                  <div className="card-data-cell remove-border-left">
                    <label>Temperature Display Unit</label> <p>{this.props.user.temperatureDisplayUnit == "F" ? "Fahrenheit" : "Celsius"}</p>
                  </div>
              </div>
            </div>

          </div>
        </div>
    );
  }
}

export default UserView;
